const square1TurnRegex = /((\()?(-?\d)\s*,\s*(-?\d)(\))?)|(\/)/g;
export function parseSquare1Algorithm(algorithm) {
    let turns = [];
    let match;
    while ((match = square1TurnRegex.exec(algorithm))) {
        if (match[0] === "/") {
            turns.push({ slice: true });
        }
        else {
            turns.push({
                top: parseInt(match[3]),
                bottom: parseInt(match[4]),
            });
        }
    }
    return turns;
}
